import ManagePortfoliosContextProvider, { useManagePortfoliosContext } from './ManagePortfoliosContext';

export { useManagePortfoliosContext };
export default ManagePortfoliosContextProvider;
